import React from 'react';
import SiteHeader from '../../shared/SiteHeader';
import SiteFooter from '../../shared/SiteFooter';
import { useEffect } from 'react';
import { getAppInsights } from '../../appInsights';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  useEffect(() => {
    document.title = 'Todonyx LLC - Home';

    const appInsights = getAppInsights();
    appInsights?.trackPageView({ name: 'Home' });
  }, []);

  return (
    <div className="page-wrapper">
      <SiteHeader />
      <div className="page-content container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <h1 className="display-5 fw-bold mb-4">Welcome to Todonyx</h1>
            <p className="lead text-muted mb-5">
              Empowering your journey with AI-driven solutions for enhanced productivity and
              creativity.
            </p>

            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <h2 className="h3 mb-3">Who We Are</h2>
                <p className="mb-0">
                  Todonyx LLC specializes in creating innovative AI-powered applications and
                  providing expert full-stack development consulting services. We combine
                  cutting-edge technology with practical solutions to help individuals and
                  businesses achieve their goals.
                </p>
              </div>
            </div>

            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <h2 className="h3 mb-3">What We Offer</h2>
                <div className="row g-3">
                  <div className="col-md-4">
                    <Link to="/products" className="nav-card-link">
                      <div className="text-center">
                        <i className="bi bi-lightbulb fs-1 text-warning mb-2"></i>
                        <h3 className="h5">Products</h3>
                        <p className="small text-muted">
                          AI-driven applications designed to enhance your daily life
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to="/services" className="nav-card-link">
                      <div className="text-center">
                        <i className="bi bi-code-slash fs-1 text-primary mb-2"></i>
                        <h3 className="h5">Services</h3>
                        <p className="small text-muted">
                          Full-stack development consulting for React, .NET, and Azure
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to="/about" className="nav-card-link">
                      <div className="text-center">
                        <i className="bi bi-chat-dots fs-1 text-success mb-2"></i>
                        <h3 className="h5">Support</h3>
                        <p className="small text-muted">
                          Dedicated assistance for all your project needs
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
};

export default Home;
